// src/mixins/showErrorModalMixin.js
import { EventBus } from './eventBus';

export default {
  methods: {
    showErrorModal(message) {
      EventBus.$emit('showErrorModal', message);
    }
  }
};



// WEBPACK FOOTER //
// ./src/request/showErrorModalMixin.js